import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { GenericComponent } from '../../misc/components/generic/generic.component';
import * as fromUserActions from '../../store/actions/user.actions';
import * as fromUserSelectors from '../../store/selectors/user.selectors';
import { MobileUsersPatchRequest } from '../../typings/mobile-users';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-farm-alerts',
  standalone: false,
  templateUrl: './farm-alerts.page.html'
})
export class FarmAlertsPageComponent extends GenericComponent {
  private store = inject(Store);
  private changeDetectorRef = inject(ChangeDetectorRef);

  subscribeToFarmAlerts = false;
  farmAlertsEmailNotifications = false;
  farmAlertsPushNotifications = false;

  ionViewWillEnter() {
    this.store.dispatch(fromUserActions.reloadMobileUser());
  }

  ionViewDidEnter() {
    this.addUniqueSubscription(
      'selectUserDetails',
      this.store.pipe(select(fromUserSelectors.selectFarmAlertsConfiguration)).subscribe((data) => {
        this.subscribeToFarmAlerts = data.subscribeToFarmAlerts;
        this.farmAlertsEmailNotifications = data.farmAlertsEmailNotifications;
        this.farmAlertsPushNotifications = data.farmAlertsPushNotifications;
        this.changeDetectorRef.detectChanges();
      })
    );
  }

  toggle(
    key: 'subscribeToFarmAlerts' | 'farmAlertEmailNotifications' | 'farmAlertPushNotifications',
    event: MouseEvent
  ) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
    const updatedData: MobileUsersPatchRequest = {};
    switch (key) {
      case 'farmAlertEmailNotifications':
        updatedData.farmAlertEmailNotifications = !this.farmAlertsEmailNotifications;
        break;
      case 'farmAlertPushNotifications':
        updatedData.farmAlertPushNotifications = !this.farmAlertsPushNotifications;
        break;
      case 'subscribeToFarmAlerts':
        updatedData.autoSubscribeFarmAlerts = !this.subscribeToFarmAlerts;
        updatedData.farmAlertEmailNotifications = !this.subscribeToFarmAlerts;
        updatedData.farmAlertPushNotifications = !this.subscribeToFarmAlerts;
        break;
    }
    this.store.dispatch(fromUserActions.updateMobileUser({ payload: updatedData }));
  }
}
